import {Typography, TypographyProps} from "@mui/material";

export interface DetailsRowProps {
    label: string;
    color?: TypographyProps["color"];
    value?: string | number | null;
    comment?: string;
}

export function DetailsTextRow(props: Readonly<DetailsRowProps>) {
    const hasValueAndComment = props.value && props.comment;

    return (
            <>
                <tr>
                    <td rowSpan={hasValueAndComment ? 2 : 1} style={{width: "var(--details-col-label-width, 30%)", verticalAlign: 'top'}}>
                        <Typography variant={"body2"}>{props.label}</Typography>
                    </td>
                    <td>
                        {props.value ? (
                                <Typography variant={"body2"} color={props.color}>
                                    <b>{props.value}</b>
                                </Typography>
                        ) : (
                                <Typography variant={"body2"} color={props.color}>
                                    <b>{props.comment}</b>
                                </Typography>
                        )}
                    </td>
                </tr>
                {hasValueAndComment && (
                        <tr>
                            <td>
                                <Typography variant={"body2"} sx={{fontStyle: 'italic'}}>
                                    {props.comment}
                                </Typography>
                            </td>
                        </tr>
                )}
            </>
    );
}
